import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("sf_token");
      window.location.href = "/login";
    }
    // Normalize FastAPI error detail into a plain string so it can never be
    // rendered as a React child (e.g. a 422 detail is a list of objects).
    const d = err?.response?.data?.detail;
    if (d !== undefined && typeof d !== "string") {
      let msg = "Request failed";
      if (Array.isArray(d)) {
        msg = d.map((e) => (e && (e.msg || e.message)) || "").filter(Boolean).join(", ") || msg;
      } else if (d && typeof d === "object") {
        msg = d.msg || d.message || JSON.stringify(d);
      }
      err.response.data.detail = msg;
    }
    return Promise.reject(err);
  }
);
